/**
 * Internal team accounts (the @squidler.io domain). These are excluded from
 * analytics two ways: their events are filtered out of PostHog insights by the
 * server-side "Internal / Test users" cohort (keyed on the email person
 * property), and — because session replay isn't governed by that cohort — their
 * session recording is stopped client-side (see lib/posthog-events). Anonymous
 * (logged-out) internal traffic can't be classified here since no email is known.
 */
export const isInternalEmail = (email: string): boolean =>
  email.toLowerCase().endsWith("@squidler.io");
